import { graphql } from '../../gql';

export const SELECTION_LISTS = graphql(`
  query SelectionLists {
    selectionList {
      region {
        id
        shortName
        longName
      }
      country {
        id
        shortName
        longName
        region
      }
      state {
        id
        shortName
        longName
        country
      }
      msa {
        id
        shortName
        longName
        region
        country
      }
      city {
        id
        shortName
        longName
        region
        country
        state
        metro_area
        count
      }
      rics_k10 {
        id
        shortName
        longName
        headcount
      }
      rics_k50 {
        id
        shortName
        longName
        rics_k10
        headcount
      }
      rics_k400 {
        id
        shortName
        longName
        rics_k10
        rics_k50
        headcount
      }
      company {
        id
        shortName
        rank
        ticker
        longName
        rics_k50: ricsK50Id
        rics_k400: ricsK400Id
        headcount
      }
      seniority {
        id
        shortName
        longName
      }
      ethnicity {
        id
        shortName
        longName
      }
      gender {
        id
        shortName
        longName
      }
      highest_degree {
        id
        shortName
        longName
      }
      skill_k75 {
        id
        shortName
        longName
        topSkills
      }
      skill_k700 {
        id
        shortName
        longName
        skill_k75
        topSkills
      }
      skill_k3000 {
        id
        shortName
        longName
        skill_k75
        skill_k700
        topSkills
      }
    }
  }
`);

// Includes all skills + geo state selection list granularities
export const EXPANDED_SELECTION_LISTS = graphql(`
  query ExpandedSelectionLists {
    selectionList {
      region {
        id
        shortName
        longName
      }
      country {
        id
        shortName
        longName
        region
      }
      state {
        id
        shortName
        longName
        country
      }
      metro_area: msa {
        id
        shortName
        longName
        region
        country
        state
      }
      city {
        id
        shortName
        longName
        region
        country
        state
        metro_area
        count
      }
      rics_k10 {
        id
        shortName
        longName
        headcount
      }
      rics_k50 {
        id
        shortName
        longName
        rics_k10
        headcount
      }
      rics_k400 {
        id
        shortName
        longName
        rics_k10
        rics_k50
        headcount
      }
      company {
        id
        shortName
        rank
        ticker
        longName
        rics_k50: ricsK50Id
        rics_k400: ricsK400Id
        headcount
      }
      seniority {
        id
        shortName
        longName
      }
      ethnicity {
        id
        shortName
        longName
      }
      gender {
        id
        shortName
        longName
      }
      highest_degree {
        id
        shortName
        longName
      }
      skill_k25 {
        id
        shortName
        longName: shortName
        label: shortName
        topSkills
      }
      skill_k50 {
        id
        shortName
        longName: shortName
        label: shortName
        topSkills
        skill_k25
      }
      skill_k75 {
        id
        shortName
        longName: shortName
        label: shortName
        topSkills
        skill_k25
        skill_k50
      }
      skill_k700 {
        id
        shortName
        longName: shortName
        label: shortName
        topSkills
        skill_k25
        skill_k50
        skill_k75
      }
      skill_k2500 {
        id
        shortName
        longName: shortName
        label: shortName
        topSkills
        skill_k25
        skill_k50
        skill_k75
        skill_k700
      }
      skill_mapped {
        id
        shortName
        longName: shortName
        label: shortName
        topSkills
        skill_k25
        skill_k50
        skill_k75
        skill_k700
        skill_k2500
      }
    }
  }
`);
